import { createSlice } from '@reduxjs/toolkit'

export const companyReducer = createSlice({
  name: 'company',
  initialState: {
    company: sessionStorage.getItem("company") ? JSON.parse(sessionStorage.getItem("company")) : null,
    companyUser: sessionStorage.getItem("userDetails") ? JSON.parse(sessionStorage.getItem("userDetails")) : null,
    workers: sessionStorage.getItem("workers") ? JSON.parse(sessionStorage.getItem("workers")) : []
  },
  reducers: {
    setCompany: (state, action) => {
      state.company = action.payload
      if(!action.payload){
        sessionStorage.removeItem("company")
      }else{
        sessionStorage.setItem("company", JSON.stringify(action.payload))
      }
    },
    
    setWorkers: (state, action) => {
      state.workers = action.payload
      if (!action.payload) {
        sessionStorage.removeItem("workers")
      } else {
        sessionStorage.setItem("workers", JSON.stringify(action.payload))
      }
    },

    setCompanyUser: (state, action) => {
      state.companyUser = action.payload
      if(!action.payload){
        sessionStorage.removeItem("userDetails")
      }else{
        sessionStorage.setItem("userDetails", JSON.stringify(action.payload))
      }
    }
  },
})

export const { setCompany , setWorkers , setCompanyUser } = companyReducer.actions

export default companyReducer.reducer